module.exports = __webpack_public_path__ + "static/img/gaozhongzhengzhi2.1186628b.jpg";